(() => {
  const root = window.Shopify?.routes?.root || '/';
  const getDrawer = () => document.querySelector('[data-cart-drawer]');
  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character]);
  const formatMoney = (cents, format) => {
    const template = format || '${{amount}}';
    const token = template.match(/\{\{\s*(\w+)\s*\}\}/)?.[1] || 'amount';
    const decimals = token.includes('no_decimals') ? 0 : 2;
    const commaDecimal = token.includes('comma');
    const value = (Number(cents || 0) / 100).toFixed(decimals);
    let [whole, decimal] = value.split('.');
    whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, commaDecimal ? '.' : ',');
    const output = decimals ? `${whole}${commaDecimal ? ',' : '.'}${decimal}` : whole;
    return template.replace(/\{\{\s*\w+\s*\}\}/, output);
  };
  const isWideScreen = () => window.matchMedia('(min-width: 900px)').matches;
  let recoDismissed = false;
  const setRecoOpen = (open) => {
    const drawer = getDrawer();
    if (!drawer) return;
    const canOpen = open && !drawer.querySelector('[data-cart-reco]')?.hidden;
    drawer.classList.toggle('reco-open', Boolean(canOpen));
    drawer.querySelector('[data-reco-toggle]')?.setAttribute('aria-expanded', String(Boolean(canOpen)));
  };
  const openDrawer = () => {
    const drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('br-cart-is-open');
    window.setTimeout(() => drawer.querySelector('.br-cart-drawer__panel')?.focus(), 30);
  };
  const closeDrawer = () => {
    const drawer = getDrawer();
    if (!drawer) return;
    setRecoOpen(false);
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('br-cart-is-open');
  };
  const shuffle = (list) => {
    for (let index = list.length - 1; index > 0; index -= 1) {
      const swap = Math.floor(Math.random() * (index + 1));
      [list[index], list[swap]] = [list[swap], list[index]];
    }
    return list;
  };
  const fetchRecommendationCards = async (url) => {
    const response = await fetch(url);
    if (!response.ok) return [];
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    return [...doc.querySelectorAll('[data-reco-product]')];
  };
  let recoSignature = null;
  const loadRecommendations = async (cart) => {
    const drawer = getDrawer();
    const wrap = drawer?.querySelector('[data-cart-reco]');
    const list = wrap?.querySelector('[data-cart-reco-list]');
    const toggle = drawer?.querySelector('[data-reco-toggle]');
    if (!wrap || !list) return;
    const inCart = new Set(cart.items.map((item) => String(item.product_id)));
    const signature = [...inCart].sort().join(',');
    if (signature === recoSignature) return;
    recoSignature = signature;
    const count = Number(drawer.dataset.recoCount || 3);
    const seeds = [...inCart];
    const seed = seeds[Math.floor(Math.random() * seeds.length)];
    const fallbackUrl = `${root}?section_id=cart-recommendations`;
    try {
      let cards = await fetchRecommendationCards(seed ? `${root}recommendations/products?product_id=${seed}&limit=10&section_id=cart-recommendations` : fallbackUrl);
      cards = cards.filter((card) => !inCart.has(card.dataset.recoProduct));
      if (seed && cards.length < count) {
        const seen = new Set(cards.map((card) => card.dataset.recoProduct));
        const extra = await fetchRecommendationCards(fallbackUrl);
        cards = cards.concat(extra.filter((card) => !inCart.has(card.dataset.recoProduct) && !seen.has(card.dataset.recoProduct)));
      }
      if (signature !== recoSignature) return;
      shuffle(cards).sort((a, b) => (Number(b.dataset.recoReviews) > 0) - (Number(a.dataset.recoReviews) > 0));
      const picks = cards.slice(0, count);
      list.replaceChildren(...picks);
      wrap.hidden = picks.length === 0;
      if (toggle) toggle.hidden = picks.length === 0;
      if (picks.length === 0) setRecoOpen(false);
      else if (isWideScreen() && !recoDismissed) setRecoOpen(true);
    } catch (error) {
      wrap.hidden = true;
      if (toggle) toggle.hidden = true;
      setRecoOpen(false);
    }
  };
  const renderCart = (cart) => {
    const drawer = getDrawer();
    if (!drawer) return;
    const moneyFormat = drawer.dataset.moneyFormat;
    const items = drawer.querySelector('[data-cart-items]');
    if (items) {
      items.innerHTML = cart.items.map((item, index) => {
        const image = item.featured_image?.url || item.image || '';
        const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p>${escapeHtml(item.variant_title)}</p>` : '';
        const resizedImage = image ? `${image}${image.includes('?') ? '&' : '?'}width=180` : '';
        return `<article class="br-drawer-item" data-cart-line="${index + 1}">
          <a class="br-drawer-item__image" href="${escapeHtml(item.url)}">${resizedImage ? `<img src="${escapeHtml(resizedImage)}" alt="${escapeHtml(item.product_title)}" width="90" height="90" loading="lazy">` : ''}</a>
          <div class="br-drawer-item__content">
            <a class="br-drawer-item__title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>${variant}
            <div class="br-drawer-item__bottom">
              <div class="br-quantity" aria-label="Cantidad de ${escapeHtml(item.product_title)}">
                <button type="button" data-cart-quantity="${item.quantity - 1}" aria-label="Quitar uno">−</button><span>${item.quantity}</span><button type="button" data-cart-quantity="${item.quantity + 1}" aria-label="Agregar uno">+</button>
              </div>
              <strong>${formatMoney(item.final_line_price, moneyFormat)}</strong>
            </div>
            <button class="br-drawer-item__remove" type="button" data-cart-quantity="0">${escapeHtml(drawer.dataset.removeLabel || 'Quitar')}</button>
          </div>
        </article>`;
      }).join('');
    }
    drawer.querySelectorAll('[data-cart-count], [data-drawer-count]').forEach((count) => { count.textContent = cart.item_count; });
    document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
    const total = drawer.querySelector('[data-cart-total]');
    if (total) total.textContent = formatMoney(cart.total_price, moneyFormat);
    drawer.querySelector('[data-cart-empty]')?.classList.toggle('br-hidden', cart.item_count > 0);
    drawer.querySelector('[data-cart-footer]')?.classList.toggle('br-hidden', cart.item_count === 0);
    const missingCopy = drawer.dataset.shippingMissing || 'Te faltan [amount] para despacho gratis';
    const reachedCopy = drawer.dataset.shippingReached || '¡Ya tienes despacho gratis!';
    drawer.querySelectorAll('[data-ship-tier]').forEach((tier) => {
      const threshold = Number(tier.dataset.threshold || 0);
      const remaining = Math.max(threshold - cart.total_price, 0);
      const percentage = threshold > 0 ? Math.min((cart.total_price / threshold) * 100, 100) : 100;
      const bar = tier.querySelector('[data-ship-tier-bar]');
      if (bar) bar.style.width = `${percentage}%`;
      bar?.parentElement?.setAttribute('aria-valuenow', String(Math.round(percentage)));
      tier.classList.toggle('is-reached', remaining === 0);
      const copy = tier.querySelector('[data-ship-tier-copy]');
      if (copy) copy.textContent = remaining > 0 ? missingCopy.replace('[amount]', formatMoney(remaining, moneyFormat)) : reachedCopy;
    });
    loadRecommendations(cart);
  };
  const refreshCart = async () => {
    const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('No pudimos actualizar el carro.');
    const cart = await response.json();
    renderCart(cart);
    return cart;
  };
  const announceCart = (message) => {
    const live = getDrawer()?.querySelector('[data-cart-live]');
    if (live) live.textContent = message;
  };

  document.addEventListener('click', (event) => {
    const cartOpen = event.target.closest('[data-cart-open]');
    if (cartOpen && getDrawer()) {
      event.preventDefault();
      recoSignature = null;
      recoDismissed = false;
      refreshCart().catch(() => {}).finally(openDrawer);
      return;
    }

    const cartClose = event.target.closest('[data-cart-close]');
    if (cartClose) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    const recoToggle = event.target.closest('[data-reco-toggle]');
    if (recoToggle) {
      event.preventDefault();
      const open = !getDrawer()?.classList.contains('reco-open');
      recoDismissed = !open;
      setRecoOpen(open);
      return;
    }

    const recoClose = event.target.closest('[data-reco-close]');
    if (recoClose) {
      event.preventDefault();
      recoDismissed = true;
      setRecoOpen(false);
      getDrawer()?.querySelector('[data-reco-toggle]')?.focus();
      return;
    }

    const quantity = event.target.closest('[data-cart-quantity]');
    if (quantity) {
      event.preventDefault();
      const line = Number(quantity.closest('[data-cart-line]')?.dataset.cartLine);
      const targetQuantity = Number(quantity.dataset.cartQuantity);
      quantity.disabled = true;
      fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity: targetQuantity })
      }).then((response) => {
        if (!response.ok) throw new Error('No pudimos cambiar la cantidad.');
        return response.json();
      }).then((cart) => {
        renderCart(cart);
        announceCart('Carro actualizado.');
      }).catch((error) => announceCart(error.message)).finally(() => { quantity.disabled = false; });
      return;
    }

    const upsell = event.target.closest('[data-upsell-add]');
    if (upsell) {
      event.preventDefault();
      upsell.disabled = true;
      if (!isWideScreen() && upsell.closest('[data-cart-reco]')) setRecoOpen(false);
      fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: upsell.dataset.upsellAdd, quantity: 1 }] })
      }).then((response) => {
        if (!response.ok) throw new Error('No pudimos agregar el producto.');
        return refreshCart();
      }).then(() => announceCart('Producto agregado al carro.')).catch((error) => announceCart(error.message)).finally(() => { upsell.disabled = false; });
      return;
    }

    const toggle = event.target.closest('[data-menu-toggle]');
    if (toggle) {
      const nav = document.querySelector('[data-main-nav]');
      const open = nav?.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(Boolean(open)));
    }

    const thumb = event.target.closest('[data-product-thumb]');
    if (thumb) {
      const gallery = thumb.closest('[data-product-gallery]');
      const target = gallery?.querySelector(`[data-product-media="${thumb.dataset.mediaId}"]`);
      if (target) {
        gallery.querySelectorAll('[data-product-media]').forEach((media) => {
          if (media !== target) {
            media.hidden = true;
            media.classList.remove('is-active');
            media.querySelector('video')?.pause();
          }
        });
        target.hidden = false;
        target.classList.add('is-active');
        gallery.querySelectorAll('[data-product-thumb]').forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
        const video = target.querySelector('video');
        if (video?.autoplay) video.play().catch(() => {});
      }
    }
  });

  document.querySelectorAll('.br-product-form, .br-sticky-form').forEach((form) => {
    const select = form.querySelector('[name="id"]');
    const price = form.closest('[data-product-root]')?.querySelector('[data-product-price]');
    const installment = form.closest('[data-product-root]')?.querySelector('[data-product-installment]');
    select?.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      if (price && option?.dataset.price) price.textContent = option.dataset.price;
      if (installment && option?.dataset.installment) installment.textContent = option.dataset.installment;
    });
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      button?.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error(await response.text());
        recoDismissed = false;
        await refreshCart();
        openDrawer();
        announceCart('Producto agregado al carro.');
      } catch (error) {
        const live = form.querySelector('[data-form-error]');
        if (live) live.textContent = error.message;
      } finally {
        button?.removeAttribute('aria-busy');
      }
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const drawer = getDrawer();
    if (!drawer?.classList.contains('is-open')) return;
    if (drawer.classList.contains('reco-open') && !isWideScreen()) {
      recoDismissed = true;
      setRecoOpen(false);
      return;
    }
    closeDrawer();
  });

  document.querySelectorAll('[data-quiz]').forEach((quiz) => {
    const questions = [...quiz.querySelectorAll('[data-question]')];
    const result = quiz.querySelector('[data-result]');
    const progress = [...quiz.querySelectorAll('[data-progress]')];
    const answers = {};
    const show = (index) => {
      questions.forEach((question, current) => { question.hidden = current !== index; });
      progress.forEach((bar, current) => bar.classList.toggle('is-active', current <= index));
    };
    quiz.addEventListener('click', (event) => {
      const option = event.target.closest('[data-answer]');
      if (!option) return;
      const index = Number(option.closest('[data-question]').dataset.question);
      answers[index] = { handle: option.dataset.product, reason: option.dataset.reason };
      sessionStorage.setItem('br-diagnostic', JSON.stringify(answers));
      if (index + 1 < questions.length) return show(index + 1);
      const picks = Object.values(answers).filter((answer) => answer.handle);
      const primary = picks[0];
      questions.forEach((question) => { question.hidden = true; });
      progress.forEach((bar) => bar.classList.add('is-active'));
      if (result) {
        result.hidden = false;
        const link = result.querySelector('[data-result-link]');
        const copy = result.querySelector('[data-result-copy]');
        if (link && primary) link.href = `${root}products/${primary.handle}`;
        if (copy) copy.textContent = picks.map((pick) => pick.reason).filter(Boolean).join(' ');
      }
    });
    show(0);
  });

  document.querySelectorAll('[data-landing-offers]').forEach((offers) => {
    const form = document.querySelector('.br-sticky-form');
    const name = document.querySelector('[data-sticky-name]');
    const price = document.querySelector('[data-sticky-price]');
    offers.addEventListener('click', (event) => {
      const offer = event.target.closest('[data-offer]');
      if (!offer) return;
      offers.querySelectorAll('[data-offer]').forEach((item) => item.classList.remove('is-active'));
      offer.classList.add('is-active');
      if (form) form.querySelector('[name="id"]').value = offer.dataset.variant;
      if (name) name.textContent = offer.dataset.name;
      if (price) price.textContent = offer.dataset.price;
    });
  });
})();
